<template>
  <button class="btn-help" @click="$bvModal.show('modal-help')">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="47.602"
      height="45.458"
      viewBox="0 0 47.602 45.458"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Retângulo_502"
            data-name="Retângulo 502"
            width="47.602"
            height="45.458"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g
        id="Grupo_846"
        data-name="Grupo 846"
        transform="translate(-1662.401 -875.4)"
        style="isolation: isolate"
      >
        <g
          id="Grupo_1327"
          data-name="Grupo 1327"
          transform="translate(1654.283 854.805)"
        >
          <g
            id="Grupo_1316"
            data-name="Grupo 1316"
            transform="translate(8.118 20.595)"
            clip-path="url(#clip-path)"
          >
            <path
              id="Caminho_2568"
              data-name="Caminho 2568"
              d="M3.932,36.991a3.964,3.964,0,0,1-1.518-.306A3.846,3.846,0,0,1,0,33.074V3.907A3.911,3.911,0,0,1,3.907,0H37.9a3.911,3.911,0,0,1,3.907,3.907V27.413A3.911,3.911,0,0,1,37.9,31.32H12.031a2.055,2.055,0,0,0-1.465.609l-3.892,3.9a3.853,3.853,0,0,1-2.742,1.159M3.907,1.839A2.071,2.071,0,0,0,1.839,3.907V33.074a2.068,2.068,0,0,0,3.533,1.46l3.892-3.9a3.882,3.882,0,0,1,2.767-1.149H37.9a2.071,2.071,0,0,0,2.068-2.068V3.907A2.071,2.071,0,0,0,37.9,1.839Z"
              fill="#fff"
            />
            <path
              id="Caminho_2569"
              data-name="Caminho 2569"
              d="M93.154,70.5H92.144V81.71a6.213,6.213,0,0,1-6.205,6.205H62.375v4.636a2.487,2.487,0,0,0,2.487,2.487H86.393a2.487,2.487,0,0,1,1.761.731l3.239,3.25a2.487,2.487,0,0,0,4.248-1.755V72.987A2.487,2.487,0,0,0,93.154,70.5"
              transform="translate(-48.039 -54.297)"
              fill="#fff"
            />
            <path
              id="Caminho_2570"
              data-name="Caminho 2570"
              d="M63.407,46.985H44.673a.919.919,0,1,1,0-1.839H63.407a.919.919,0,1,1,0,1.839"
              transform="translate(-33.698 -34.77)"
              fill="#fff"
            />
            <path
              id="Caminho_2571"
              data-name="Caminho 2571"
              d="M57.358,73.3H44.673a.919.919,0,1,1,0-1.839H57.358a.919.919,0,1,1,0,1.839"
              transform="translate(-33.698 -55.039)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
    <p>{{ $t("configSite.btns.help") }}</p>
  </button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.btn-help {
  width: 94px;
  height: 114px;
  position: fixed;
  right: 0;
  bottom: 175px;
  border-radius: 20px 0 0 20px;
  background: var(--color-green-4);
  border: 0;
  padding: 0;
  @media (max-width: 991px) {
    width: 70px;
    height: 70px;
    border-radius: 15px 0 0 15px;
  }
  svg {
    margin-bottom: 12px;
    @media (max-width: 991px) {
      max-width: 30px;
      max-height: 30px;
      margin-bottom: 5px;
    }
  }
  p {
    font-size: 18px;
    font-family: "Font Regular";
    color: var(--color-white);
    margin-bottom: 0;
    @media (max-width: 991px) {
      font-size: 14px;
    }
  }
}
</style>
